module.exports = __webpack_public_path__ + "static/seres-silk-duvet-2-d142a00347bb1e13a99d91846e3748c0.webp";